import { render, staticRenderFns } from "./my_news.vue?vue&type=template&id=f5b97ec2&scoped=true"
import script from "./my_news.vue?vue&type=script&lang=js"
export * from "./my_news.vue?vue&type=script&lang=js"
import style0 from "./my_news.vue?vue&type=style&index=0&id=f5b97ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b97ec2",
  null
  
)

export default component.exports